import { DECISION_COMPLAINT } from 'CorePackage/MainModule/routes/routes';
import { appealStatusSelectOptions } from 'KnmErknmPackage/MainModule/constants/appealStatusSelectOptions';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Section } from 'UIPackage/FormModule/components/Section';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';

export const DecisionAppealStatus = () => {
  return (
    <Section title="Сведения о жалобах на действия и решения КНО и их должностных лиц" id={DECISION_COMPLAINT}>
      <FieldBlock>
        <SelectInputField
          name="appealStatus"
          size="medium"
          options={appealStatusSelectOptions}
          disabled
          isClearable={false}
        />
      </FieldBlock>
    </Section>
  );
};
